import React from "react";
import Styled from "./styles";
import TitleHeader from "../../EducationInfo/TitleHeader";
import Table from "../../Table";
import PNDSLookup from "../../HealthPlans/PNDSLookup";

const HealthPlans = ({ healthPlanContract = [], noDataMessage, pndsHealthPlans }) => {
  const columns = [
    { name: "healthPlanName", label: "", width: "100" },
  ];

  let updatedDataMessage = noDataMessage;
  if (
    !(
      updatedDataMessage === "Profile under Development" ||
      updatedDataMessage === "Dr.'s survey not received"
    )
  ) {
    updatedDataMessage = "The physician did not supply this information";
  } else if (!updatedDataMessage) {
    updatedDataMessage = "None reported";
  }

  const columnsPnds = [
    { name: "networkPlanName", label: "", width: "100" },
  ];

  let updatedDataMessagePnds = noDataMessage;
  if (
    !(
      updatedDataMessagePnds === "Profile under Development for PNDS Health plans information" ||
      updatedDataMessagePnds === "Dr.'s survey not received for PNDS Health plans information"
    )
  ) {
    updatedDataMessagePnds = "The physician did not supply PNDS Health plans information";
  } else if (!updatedDataMessagePnds) {
    updatedDataMessagePnds = "None reported";
  }

  return (
    <Styled>
      
      <TitleHeader label="Physician’s Provider Network Data System (PNDS) Listed Heath Plans" lastUpdatedDate={healthPlanContract?.[0]?.informationDate} />
      {pndsHealthPlans && pndsHealthPlans.length > 0 ? (
        <>
        <Table
          columns={columnsPnds}
          data={pndsHealthPlans.map((p) => {
            let networkPlanName = p.networkPlanName;
            if (!networkPlanName) {
              networkPlanName = updatedDataMessage;
            }
            let otherPlanText = p.otherPlanText;
            if (otherPlanText) {
              networkPlanName = otherPlanText;
            }

            return { ...p, networkPlanName: networkPlanName };
          })}
        />
        </>
      ) : (
        <p>{updatedDataMessagePnds}</p>
      )}
      <PNDSLookup />
      <hr />
      <p >
        <strong>Note: </strong>The Department obtains information using provider
        network participation information, or other reliable sources of
        information submitted by health care plans. To verify physician
        participation, contact the physician and/or plan.
      </p>
      <br />

      <TitleHeader label="Physician Reported Health Plans" lastUpdatedDate={healthPlanContract?.[0]?.informationDate} />
      {healthPlanContract && healthPlanContract.length > 0 ? (
        <Table
          columns={columns}
          data={healthPlanContract.map((p) => {
            let healthPlanName = p.healthPlanName;
            if (!healthPlanName) {
              healthPlanName = updatedDataMessage;
            }
            let otherPlanText = p.otherPlanText;
            if (otherPlanText) {
              healthPlanName = otherPlanText;
            }

            return { ...p, healthPlanName: healthPlanName };
          })}
        />
      ) : (
        <p>{ updatedDataMessage }</p>
      )}
      <hr />
      {healthPlanContract && healthPlanContract.length > 0 && (
        <p>
          <strong>Note:</strong> Contact the doctor's office to see if this
          doctor is taking new patients.
        </p>
      )}
    </Styled>
  );
};

export default HealthPlans;
